<template>
  <div class="wrapper">
    <HeaderNav v-if="!$store.state.isNavBarOff" :auth="$store.state.isAuth" />

    <v-snackbar :transition="'slide-y-transition'" text-color="white" color="#C62828" top timeout="3000" v-model="snackbarError">
      {{ snackbarText }}
    </v-snackbar>

    <v-form ref="form" lazy-validation>
      <div class="outer">
        <div class="title__wrap">
          <h1>Персональные данные</h1>
          <p>Для участия в акции укажите ФИО и банк к которому привязан ваш номер телефона.</p>
        </div>
        <div class="inputs">
          <v-text-field
            v-model="lastname"
            @blur="validateLastName"
            label="Фамилия"
            autocomplete="name"
            :rules="lastnameRules"
            dense
            outlined
            class="fio-field email-field"
            :class="{ 'error-input': this.lastnameRules.length > 0 }"
            required
            clearable
          >
          </v-text-field>

          <v-text-field
            v-model="firstname"
            @blur="validateFirstName"
            label="Имя"
            autocomplete="name"
            :rules="firstnameRules"
            dense
            outlined
            class="fio-field email-field"
            :class="{ 'error-input': this.firstnameRules.length > 0 }"
            required
            clearable
          >
          </v-text-field>
          <v-text-field
            v-model="patronymic"
            @blur="validatePatronymic"
            label="Отчество"
            autocomplete="name"
            dense
            outlined
            :rules="patronymicRules"
            class="fio-field email-field"
            :class="{ 'error-input': this.patronymicRules.length > 0 }"
            clearable
          >
          </v-text-field>
          <v-text-field
            v-model="phone"
            label="Телефон"
            placeholder="+7"
            :rules="phoneRules"
            dense
            disabled
            v-mask="'+7 (###) ###-##-##'"
            outlined
            class="email-field"
            :class="{ 'error-input': this.phoneRules.length > 0 }"
            clearable
            v-on:focus="focus"
            v-on:focusout="focusout"
            v-on:keydown.delete="
              () => {
                if (phone?.length <= 2) {
                  $event.preventDefault();
                }
              }
            "
            v-on:keydown.backspace="
              () => {
                if (phone?.length <= 2) {
                  $event.preventDefault();
                }
              }
            "
          >
          </v-text-field>

          <div class="bank-check">
            <v-autocomplete
              v-model="selectedBank"
              :items="filteredBankList"
              :loading="isLoadingBanks"
              :search-input.sync="bankSearch"
              item-text="name_rus"
              item-value="id"
              :label="!$store.state.selectedBank ? 'Выберите банк' : 'Ваш банк'"
              outlined
              :rules="bankRules"
              dense
              no-filter
              clearable
              @update:search-input="filterBanks"
              :class="{ 'bank-field': !this.selectedBank }"
              no-data-text="Банков не найдено"
              :disabled="!!$store.state.selectedBank"
              hide-details
            >
              <template v-slot:selection="{ item }"> {{ item.name_rus }}</template>
            </v-autocomplete>
            <p v-if="!$store.state.selectedBank" class="bank-hint">
              Для выплаты через Систему быстрых платежей (СБП) выберите банк,
              <strong class="strong-text">к которому привязан ваш номер телефона</strong>.Банк можно выбрать один раз.
            </p>
          </div>
        </div>

        <v-btn :disabled="!isFormValid" depressed :color="'primary'" class="next-btn" block @click="register">
          <div class="btn-content-container">Сохранить</div>
        </v-btn>
        <p class="politic">
          Для изменения номера телефона или банка свяжитесь с
          <a :href="promoEmail" style="color: green; text-decoration: none; font-size: 12px" target="_blank">технической поддержкой</a>
        </p>
      </div>
    </v-form>
  </div>
</template>

<script>
import HeaderNav from "@/components/HeaderNav.vue";
import jwt_decode from "jwt-decode";
import axios from "axios";
import { mapActions } from "vuex";

function containsInvalidChars(str) {
  if (!str || !str.trim()) return true;
  return !/^[а-яА-ЯёЁa-zA-Z]+(?:-[а-яА-ЯёЁa-zA-Z]+)*$/.test(str.trim());
}

export default {
  props: {},
  data() {
    return {
      promoEmail: process.env.VUE_APP_PROMO_EMAIL,
      user_id: jwt_decode(this.$cookies.get("cng_token"))["id"],
      firstname: this.$store.state.fio ? this.$store.state.fio.split(" ")[1] : "",
      lastname: this.$store.state.fio ? this.$store.state.fio.split(" ")[0] : "",
      patronymic: this.$store.state.fio ? this.$store.state.fio.split(" ")[2] : "",
      phone: this.$store.state.phone || "",
      phoneRules: [],
      firstnameRules: [],
      lastnameRules: [],
      patronymicRules: [],
      bankRules: [],
      bankList: [],
      filteredBankList: [],
      selectedBank: null,
      isLoadingBanks: false,
      bankSearch: "",
      snackbarError: false,
      snackbarText: "",
      isFormLoaded: false,
    };
  },
  computed: {
    isFormValid() {
      return this.validateLastName() && this.validateFirstName() && this.validatePatronymic() && this.validateBank();
    },
  },
  methods: {
    ...mapActions({
      getUserData: "getUserData",
    }),

    focus() {
      if (this.phone?.length <= 2 || this.phone === null) {
        this.phone = "+7";
      }
    },

    filterBanks(search) {
      if (!search) {
        this.filteredBankList = [...this.bankList];
        return;
      }

      const searchLower = search.toLowerCase();
      this.filteredBankList = this.bankList.filter((bank) => bank.name.toLowerCase().includes(searchLower));
    },

    async fetchBanks() {
      try {
        this.isLoadingBanks = true;
        const { data } = await axios.get(`${process.env.VUE_APP_NT}/prostodar/get-bank-information`);
        this.bankList = data.data || [];
        this.filteredBankList = [...this.bankList];
      } catch (error) {
        console.error("Ошибка при загрузке банков:", error);
      } finally {
        this.isLoadingBanks = false;
      }
    },
    async fetchUserBank() {
      try {
        this.isLoadingBanks = true;
        const { data } = await axios.get(`${process.env.VUE_APP_NT}/prostodar/get-bank-information/${this.$store.state.selectedBank}`);
        this.selectedBank = data.data.id;
      } catch (error) {
        console.error("Ошибка при загрузке банка пользователя", error);
      } finally {
        this.isLoadingBanks = false;
      }
    },
    async focusout() {
      if (this.phone?.length <= 2 || this.phone === null) {
        this.phone = "";
        await this.$nextTick();
        this.phone = "";
      }
    },

    register: async function () {
      const isLastNameValid = this.validateLastName();
      const isFirstNameValid = this.validateFirstName();
      const isPatronymicValid = this.validatePatronymic();
      const isBankValid = this.validateBank();

      if (!isLastNameValid || !isFirstNameValid || !isPatronymicValid || !isBankValid) {
        return;
      }

      try {
        const fioOneString = [this.lastname, this.firstname, this.patronymic].filter(Boolean).join(" ");
        const { data } = await axios.patch(`${process.env.VUE_APP_MYHOST}`, {
          id: this.user_id,
          bank_id: this.selectedBank || this.$store.state.selectedBank,
          fio: fioOneString,
        });
        this.$store.commit("setSelectedBank", this.selectedBank);
        this.$store.commit("isAcitvetedUser", true);
        this.$store.commit("changeFio", fioOneString);
        this.$cookies.set("cng_token", data.jwt);
        this.$router.push({ name: "LcMain" }).catch(() => {});
      } catch (error) {
        this.snackbarText = this.getErrorMessage(error);
        this.snackbarError = true;
        console.error(error.message);
      }
    },

    validateLastName() {
      if (!this.isFormLoaded) return true;
      const lastNamePattern = /^[А-ЯЁа-яё]{2,36}(-[А-ЯЁа-яё]{2,20})?$/;
      if (!this.lastname || !this.lastname.trim()) {
        this.lastnameRules = ["Обязательное поле"];
        return false;
      }

      if (containsInvalidChars(this.lastname)) {
        this.showErrorToast("Фамилия может содержать только буквы и дефис (если требуется)");
        this.lastnameRules = ["Допустимы только буквы и дефис"];
        return false;
      }
      if (!lastNamePattern.test(this.lastname)) {
        if (this.lastname.length < 2) {
          this.lastnameRules = ["Минимум 2 символа"];
        } else if (this.lastname.length > 36) {
          this.lastnameRules = ["Максимум 36 символов"];
        } else {
          this.lastnameRules = ["Некорректный формат"];
        }
        return false;
      }

      this.lastnameRules = [];
      return true;
    },

    validateFirstName() {
      if (!this.isFormLoaded) return true;
      if (!this.firstname || !this.firstname.trim()) {
        this.firstnameRules = ["Обязательное поле"];
        return false;
      }

      if (containsInvalidChars(this.firstname)) {
        this.firstnameRules = ["Допустимы только буквы и дефис"];
        return false;
      }

      const firstNamePattern = /^[А-ЯЁа-яё]{2,30}$/;
      if (!firstNamePattern.test(this.firstname)) {
        if (this.firstname.length < 2) {
          this.firstnameRules = ["Минимум 2 символа"];
        } else if (this.firstname.length > 30) {
          this.firstnameRules = ["Максимум 30 символов"];
        } else {
          this.firstnameRules = ["Некорректный формат"];
        }
        return false;
      }

      this.firstnameRules = [];
      return true;
    },

    validatePatronymic() {
      if (!this.isFormLoaded) return true;
      if (this.patronymic && this.patronymic.trim()) {
        if (containsInvalidChars(this.patronymic)) {
          this.patronymicRules = ["Допустимы только буквы и дефис"];
          return false;
        }

        const patronymicPattern = /^[А-ЯЁа-яё]{2,30}$/;
        if (!patronymicPattern.test(this.patronymic)) {
          if (this.patronymic.length < 2) {
            this.patronymicRules = ["Минимум 2 символа"];
          } else if (this.patronymic.length > 30) {
            this.patronymicRules = ["Максимум 30 символов"];
          } else {
            this.patronymicRules = ["Некорректный формат"];
          }
          return false;
        }
      }
      this.patronymicRules = [];
      return true;
    },
    validateBank() {
      if (!this.isFormLoaded) return true;

      if (!this.selectedBank && !this.$store.state.selectedBank) {
        this.showErrorToast("Пожалуйста, выберите банк");
        this.bankRules = ["Выберите банк"];
        return false;
      }

      this.bankRules = [];
      return true;
    },

    showErrorToast(message) {
      this.snackbarText = message;
      this.snackbarError = true;
      setTimeout(() => {
        this.snackbarError = false;
      }, 3000);
    },
  },

  watch: {
    async phone() {
      if (this.phone === null) {
        await this.$nextTick();
        this.phone = "+7";
      }
      this.phoneRules = [];
    },
    firstname() {
      this.firstnameRules = [];
    },
    lastname() {
      this.lastnameRules = [];
    },
    selectedBank() {
      this.bankRules = [];
    },
  },
  async mounted() {
    await this.getUserData();

    this.fetchBanks();

    if (this.$store.state.selectedBank) {
      await this.fetchUserBank();
    }

    const fioParts = this.$store.state.fio ? this.$store.state.fio.split(" ") : ["", "", ""];
    this.lastname = fioParts[0] || ""; // Фамилия
    this.firstname = fioParts[1] || ""; // Имя
    this.patronymic = fioParts[2] || "";
    this.phone = this.$store.state.phone || "";
    this.selectedBank = this.$store.state.selectedBank || null;

    this.isFormLoaded = true;
  },
  components: { HeaderNav },
};
</script>

<style lang="scss" scoped>
.wrapper {
  width: 100%;
  margin: 0 !important;
  padding: 0 !important;
}
.title__wrap {
  display: flex;
  flex-direction: column;
  gap: 18px;
  margin-bottom: 48px;
}
.title__wrap p {
  font-family: "Inter";
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 130%;
  text-align: center;
  letter-spacing: -0.015em;

  color: #1a1a1a;
}
.inputs .fio-field {
  margin-bottom: 10px !important;
}
.v-form h1 {
  font-family: "PT Sans";
  font-weight: 700;
  font-size: 20px;
  line-height: 22px;
  letter-spacing: -0.005em;
  text-align: center;
}

.v-form,
.form {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.v-form {
  background: var(--block-color);
  width: 100%;

  border-radius: 16px;
}

.strong-text {
  color: #a7112d;
}

.bank-field {
  ::v-deep {
    .v-input__slot {
      border: 2px red solid !important;
    }

    .v-label {
      color: red !important;
    }

    .v-label--active {
      color: red !important;
    }

    /* Дополнительно можно изменить цвет других элементов */
    .v-input__control::before,
    .v-input__control::after {
      border-color: red !important;
    }
  }
}

.btn-content-container {
  color: var(--white-color);
}

.next-btn {
  font-weight: 700;
  font-size: 16px;
  line-height: 24px;
  margin-top: 50px;
  color: #fff;
}
.politic {
  margin-top: 5px;
  font-family: "Inter";
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 130%;
  text-align: center;
  letter-spacing: -0.015em;

  color: #868686;
}
.politic a {
  color: #868686;
}

.bank-hint {
  font-size: 14px;
  color: black;
  margin-top: 5px;
  margin-bottom: 15px !important;
  text-align: center;
}
.bank-check {
  margin-top: 15px;
}

@media screen and (max-width: 4000px) and (min-width: 769px) {
  .apruve-container {
    max-width: 800px;
  }
  .outer {
    max-width: 380px;
    width: 100%;
    padding: 80px 0;
    align-self: center;
    gap: 30px !important;
  }

  .title__wrap h1 {
    font: 700 36px "PT Sans";
    text-align: center;
    line-height: 110%; /* 44px */
    letter-spacing: -0.2px;
  }

  .politic-checkbox {
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
  }

  .politic {
    text-align: center;
    margin-top: 5px;
  }

  .politic a {
    font: 400 14px "Inter";
    line-height: 130%; /* 18.2px */
    letter-spacing: -0.21px;
  }
}
</style>
